import React, { useState, useEffect, useRef } from 'react'
import Vendor from './types/Vendor'

export default function VendorPicker({
	setVendors,
	vendors,
	modalRef,
} :
{
	setVendors: (vendors: Vendor[]) => void,
	vendors: Vendor[],
	modalRef: React.RefObject<HTMLDivElement>,
}) {
	const [search, setSearch] = useState<string>('')
	const vendorPickerRef = useRef<HTMLDivElement>(null)
	const vendorFormRef = useRef<HTMLDivElement>(null)

	useEffect(() => {
		const selectedVendor = vendors.find((v) => v.selected)
		modalRef.current?.classList.toggle('long-bottom', !selectedVendor)
		
		return () => {
			modalRef.current?.classList.remove('long-bottom')
		}
	}, [vendors])

	const selectedVendor = vendors.find((v) => v.selected)
	const q = search.toLowerCase().trim()
	const results = selectedVendor ? [selectedVendor] : vendors.filter((vendor) => {
		return (
			vendor.name.toLowerCase().includes(q) ||
			(vendor.badge_id && vendor.badge_id.toString() === q)
		)
	})
	// .sort((a, b) => {
	// 	if (a.name < b.name) return -1
	// 	if (a.name > b.name) return 1
	// 	return 0
	// })

	const chooseVendor = (vendor: Vendor) => {
		setVendors(vendors.map((v) => {
			v.selected = (v.id === vendor.id)
			return v
		}))
		setSearch('')
		modalRef.current?.scrollTo(0, vendorPickerRef.current?.offsetTop || 0)
		// modalRef.current?.scrollTo({
		// 	top: vendorPickerRef.current?.offsetTop || 0,
		// 	behavior: 'smooth',
		// })
	}

	const clearVendor = (vendor: Vendor) => {
		setVendors(vendors.map((v) => {
			v.selected = false
			return v
		}))
	}

	const clickVendor = (vendor: Vendor) => {
		return (e: React.MouseEvent<HTMLButtonElement>) => {
			vendor.selected ? clearVendor(vendor) : chooseVendor(vendor)
		}
	}

	const query = new URLSearchParams(window.location.search);
	const queryVendor = parseInt(query.get('badge') || '', 10)

	return (
		<div className='vendor-picker' ref={vendorPickerRef}>
			{!selectedVendor && (
				<div className="vendor-form" ref={vendorFormRef}>
					<label htmlFor="search">
						Search Vendors or Choose from List
					</label>
					<input
						id="search"
						placeholder="Find by Name or Badge Number..."
						type="search"
						value={search}
						autoComplete='off'
						autoCorrect='off'
						autoCapitalize='off'
						onFocus={(e) => {
							modalRef.current?.scrollTo(0, vendorFormRef.current?.offsetTop || 0)
						}}
						onChange={(e) => {
							setSearch(e.target.value)
							modalRef.current?.scrollTo(0, vendorFormRef.current?.offsetTop || 0)
						}}
					/>
				</div>
			)}
			<div className='vendor-list'>
				{results.map((vendor) => (
					<div
						key={vendor.id}
						className={"vendor" + (vendor.selected ? " vendor-selected" : "")}
					>
						{vendor.image.cover.url !== '' ?
							<img src={vendor.image.cover.url} /> :
							<div className="vendor-image-placeholder" />
						}
						<div className="info">
							<h3>{vendor.name}</h3>
							{vendor.badge_id && <p>Badge {vendor.badge_id}</p>}
						</div>
						{vendor.selected && <button type='button' onClick={clickVendor(vendor)} className={'button button--outline button--on-black'}>Change</button>}
						{!vendor.selected && <button type='button' onClick={clickVendor(vendor)} className={'button'}>Pay</button>}
					</div>
				))}
				{results.length === 0 && (
					<p className='no-result'>No vendors found with <br />that name or badge number.</p>
				)}
			</div>
		</div>
	)
}